import { getAPIClient } from "../helpers";
import type { UpdateRestaurantProfileData } from "../../api/routes/shop/routes/restaurant_profile";

export const restaurantProfileAPI = {
  // PUT /restaurant-profile - Update restaurant profile
  updateRestaurantProfile: async (data: UpdateRestaurantProfileData) => {
    const hc = getAPIClient();
    const resp = await hc.api.v2["restaurant-profile"].$put({
      json: data,
    });

    if (!resp.ok) {
      const error = await resp
        .json()
        .catch(() => ({ error: "Failed to update restaurant profile" }));
      throw new Error(
        (error as any).error ||
          `Failed to update restaurant profile: ${resp.status}`,
      );
    }

    return await resp.json();
  },
};
